// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_iYM","cls2":"PaywallPage-cls2_s8R PaywallPage-cls1_iYM"};